import React from 'react';
import { Consumer } from 'contexts/BrowserHistory/BrowserHistoryContext';

export default Component => props => (
    <Consumer>
        {({ state }) => (
            <Component {...props} location={state?.location || {}} />
        )}
    </Consumer>
);
